import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

/**
 * 🆕 09/07/2026 — CollapsiblePanel condiviso (estratto da LookupLists.jsx per riuso)
 */
export const CollapsiblePanel = ({ title, subtitle, emoji = "📋", defaultOpen = false, testid, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 mt-4 overflow-hidden" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3 hover:bg-slate-50 transition-colors"
        data-testid={`${testid}-toggle`}
      >
        <div className="flex items-center gap-3 text-left min-w-0">
          {open ? <ChevronDown className="h-4 w-4 text-slate-500 flex-shrink-0" /> : <ChevronRight className="h-4 w-4 text-slate-500 flex-shrink-0" />}
          <div className="min-w-0">
            <h2 className="text-base font-semibold text-slate-900 flex items-center gap-2 truncate">{emoji} {title}</h2>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5 truncate">{subtitle}</p>}
          </div>
        </div>
        <span className="text-xs font-medium text-slate-400 flex-shrink-0">{open ? "—" : "+"}</span>
      </button>
      {open && <div className="px-5 pb-5 pt-1 border-t border-slate-100">{children}</div>}
    </div>
  );
};

export default CollapsiblePanel;
